import { Button, Grid2, Modal } from "@mui/material";
import React from "react";
import "./index.scss";

const CustomModalConfirm = ({
  open,
  handleClose,
  textTitle = null,
  textBody = null,
  textConfirmButton,
  textCancleButton,
  functionConfirm = () => {},
}) => {


  return (
    <Modal open={open} className="modal-box-container-payment">
      <Grid2
        className="parent-content-modal-payment"
        container
        columns={12}
        dir="rtl"
      >
        {textTitle !== null && (
          <Grid2 className="title-text" item size={{ xs: 12 }}>
            {textTitle}
          </Grid2>
        )}
        {textBody !== null && (
          <Grid2 className="body-text" item size={{ xs: 12 }}>
            <Grid2 container direction="column">
            {textBody.split("@@").map((text)=><Grid2 item xs={12}>{text}</Grid2>)}
            {/* {textBody} */}
            </Grid2>
          </Grid2>
        )}

        <Grid2 className="box-button" container columns={12} spacing={1}>
        <Grid2 item size={{ xs: 3 }}>
            <Button className="reject" onClick={handleClose}>
              {textCancleButton}
            </Button>
          </Grid2>
          <Grid2 item size={{ xs: 9 }}>
            <Button className="confirm" onClick={functionConfirm}>
              {textConfirmButton}
            </Button>
          </Grid2>
        </Grid2>
      </Grid2>
    </Modal>
  );
};

export default CustomModalConfirm;
